
@if(page) {
  <h2 class="title">{{ page.title }}</h2>
   
  <div class="page-content" [innerHTML]="page.content"></div>
  <div class="page-meta">
    <small>Utworzono: {{ page.created | date:'yyyy-MM-dd HH:mm' }}</small>
    <small>Aktualizacja: {{ page.updated | date:'yyyy-MM-dd HH:mm' }}</small>
  </div>


}